interface WhiteLabelTarget {
  target: string;
  description: string;
  icon: {
    white: string;
    black: string;
    style?: string;
  };
  logo: {
    white: string;
    black: string;
    style?: string;
  };
}

const getWhiteLabelTarget = (): WhiteLabelTarget | null => {
  if (location.href.includes('paid.behamics.com')) {
    return {
      target: 'paid',
      description: 'Paid',
      icon: {
        white: 'assets/img/paid_icon.svg',
        black: 'assets/img/paid_icon.svg',
      },
      logo: {
        white: 'assets/img/paid_logo.svg',
        black: 'assets/img/paid_logo.svg',
        style: 'height: 30px; margin-bottom: 20px',
      },
    };
  }

  if (location.href.includes('wellblum.behamics.com')) {
    return {
      target: 'wellblum',
      description: 'Wellblum',
      icon: {
        white: 'assets/img/wellblum_icon.png',
        black: 'assets/img/wellblum_icon.png',
      },
      logo: {
        white: 'assets/img/wellblum_logo.svg',
        black: 'assets/img/wellblum_logo_white.svg',
        style: 'height: 20px; margin-bottom: 20px',
      },
    };
  }

  return null;
};

export const whiteLabelTarget = getWhiteLabelTarget();
